import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmationDialogData {
	title: string  | undefined;
	message: string;
}

@Component({
	templateUrl: 'confirmation-dialog.html'
	// ,styleUrls: ['confirmation-dialog.css']
})
export class ConfirmationDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
	) {	}
}